import { GetStaticProps } from "next";
import React from "react";
import settings from "../constants/settings";
import Head from "next/head";
import ComponentsSearchPage from "../components/component-search/ComponentsSearchPage";
import { Category } from "../reducers/models/categories";
import { FlashPCBPage } from "../models/page";
import { RED_GRADIENT } from "../constants/Styles";
import GlobalStyle from "../components/GlobalStyle";
import { useRouter } from "next/router";

export interface ComponentsPageProps {
  categories: Category[];
}

const Components: FlashPCBPage<ComponentsPageProps> = ({ categories }) => {
  return (
    <>
      <Head>
        <title>Explore Parts</title>
        <meta
          name="description"
          content="Search the FlashPCB components and start designing your board."
        />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <ComponentsSearchPage categories={categories} />
    </>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  const response = await fetch(`${settings.api_url}/parts/categories`);
  const { categories } = (await response.json()) as {
    categories: Category[];
  };

  return {
    props: {
      categories,
    },
  };
};

Components.GlobalStyle = function ComponentsGlobalStyle() {
  const router = useRouter();
  return (
    <GlobalStyle
      background={
        router.query.searchTerms === undefined ? RED_GRADIENT : undefined
      }
    />
  );
};

export default Components;
